/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Sendreset1Inputs */

const zh_password_sendreset1 = /** @type {(inputs: Password_Sendreset1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送密码重置邮件`)
};

const en_password_sendreset1 = /** @type {(inputs: Password_Sendreset1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send password reset email`)
};

const es_password_sendreset1 = /** @type {(inputs: Password_Sendreset1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar correo de restablecimiento`)
};

/**
* | output |
* | --- |
* | "Send password reset email" |
*
* @param {Password_Sendreset1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const password_sendreset1 = /** @type {((inputs?: Password_Sendreset1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Sendreset1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_sendreset1(inputs)
	if (locale === "en") return en_password_sendreset1(inputs)
	return es_password_sendreset1(inputs)
});
export { password_sendreset1 as "password_sendReset" }